var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('btn-default',{attrs:{"color":"#EB5757","count":"12","response":false,"text":"Выгрузить в Controll","icon":"mdi-arrow-up"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }